var map = {
	"./avatar.jpg": 4657,
	"./conference.641521c4.png": 4000,
	"./conference.png": 8094,
	"./cuhk.png": 6972,
	"./logo_black.png": 9686,
	"./logo_white.png": 2759,
	"./lws.png": 1803,
	"./signature.png": 6388,
	"./signature_adj.png": 8138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;